/**
 * Password validation — same complexity rules as the app's signup / reset flows.
 * (Ported from juristab-frontend-app utils/passwordValidation.js.)
 */

export interface ValidationResult {
  valid: boolean;
  message: string;
}

/** Validate password complexity: min 8 chars, one uppercase, one number, one special. */
export function validatePasswordComplexity(password: string): ValidationResult {
  if (!password || password.length < 8) {
    return { valid: false, message: 'Password must be at least 8 characters' };
  }
  if (!/[A-Z]/.test(password)) {
    return { valid: false, message: 'Password must contain at least one uppercase letter' };
  }
  if (!/\d/.test(password)) {
    return { valid: false, message: 'Password must contain at least one number' };
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    return { valid: false, message: 'Password must contain at least one special character' };
  }
  return { valid: true, message: '' };
}
